import { ChromeAppMessage } from 'Environment/ChromeApp/types';
import { clientType } from 'Environment/getClientType';
import { tryDeliverTokenViaStarterSdk } from 'Environment/Html5/CWAStarterSDK';
import { HTML5Client } from 'Environment/launchResource/html5Client';
import { ChromeAndHtml5 } from 'GlobalAppConfigService/ChromeAppHtml5/common';
import {
	invokeMessageHandler,
	preHtml5LaunchMessages,
} from 'GlobalAppConfigService/ChromeAppHtml5/preHtml5LaunchMessages';
import { Dependencies } from 'GlobalAppConfigService/types';
import { GacsHtmlChromeAppTransportBase } from './gacsTransportBase';

export class GacsHtml5Transport extends GacsHtmlChromeAppTransportBase {
	// During WSUI login, the HTML5 client may not available so this is optional.
	private readonly html5client?: HTML5Client;

	public constructor(dependencies: Dependencies, html5client?: HTML5Client) {
		super(dependencies, clientType.html5);
		this.html5client = html5client;
	}

	protected postMessage(message: ChromeAppMessage): void {
		if (preHtml5LaunchMessages.includes(message.header.type)) {
			invokeMessageHandler(message);
			return;
		}

		this.html5client?.sendEvent(message);
	}

	// Prefer SharedWorker (Starter SDK) delivery when available; otherwise fall back
	// to the postMessage channel.
	protected async deliverAppConfigToken(
		tokenData: ChromeAndHtml5.TokenData
	): Promise<void> {
		const handled = await tryDeliverTokenViaStarterSdk(
			tokenData.accesstoken,
			this.dependencies.getWSConfig()
		);
		if (!handled) {
			await super.deliverAppConfigToken(tokenData);
		}
	}
}
